import '../../src/Css/bootstrap.min.css';
import '../../src/App.css';
import Menu from '../Components/Header/Menu';
import MenuWide from '../Components/Header/MenuWide';
import HomePage from './pages/index'
import Service from './pages/Service';
import Tasks from './pages/tasks';
import Loader from 'react-loader-spinner';
import GuaranteeCardStatus from './pages/GuaranteeCardStatus';
import GuaranteeStatusResult from './pages/GuaranteeStatusResult';
import ForgetPassword from './pages/ForgetPassword';
import Profile from "./pages/Profile";
import RequestPassword from "./pages/RequestPassword";
import ServiceInvoice from "./pages/ServiceInvoice";
import MyTasks from "./pages/MyTasks";
import { useState, useEffect, Fragment } from 'react';
import PartRequest from "./pages/PartRequest";
import UserProfile from './pages/UserProfile';
import SearchCommands from '../Pages/SearchCommands';
import MyCommands from './pages/MyCommands';
import Commnands from './pages/Commands';
import SearchProductRequest from './pages/SearchProductRequest';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ModalDialog from './Components/Tasks/ModalDialog';
import ModalEnlargeImage from "./Common/ModalEnlargeImage";
import PopupMenu from './Components/PopupMenu';
import PrintViewer from '../Pages/PrintViewer';
import { getActiveSubsystems, isMobileApp, isWebApp } from '../store/api/CommonFunctions';
import { useDispatch } from 'react-redux';
import AddEditStaff from './pages/AddEditStaff';
import SearchStaff from './pages/SearchStaff';
import { getAppConfig } from '../store/api/SystemSettingsAPI';
import CustomerRequestWithoutLoginList from './pages/CustomerRequestWithoutLoginList';
import ServiceRejectHistory from './pages/ServiceRejectHistory';
import ManageTransportationChart from './pages/ManageTransportationChart';
import ManageSendingStaffList from './pages/ManageSendingStaffList';
import UserDashboard from '../Pages/UserDashboard';
import SearchSentSMS from '../Pages/SearchSentSMS';
import ModalSMSTemplates from '../Components/Modals/ModalSMSTemplates';
import SearchReceivedSMS from '../Pages/SearchReceivedSMS';
import GuaranteeCardsManagement from './pages/GuaranteeCardsManagement';
import ProductBugDetailedReport from './pages/ProductBugDetailedReport';
import ServiceAccountingReport from './pages/ServiceAccountingReport';
import DefinedServiceCostAggregateReport from './pages/DefinedServiceCostAggregateReport';
import DefinedServiceCostDetailedReport from './pages/DefinedServiceCostDetailedReport';
import StaffPerformanceTotalCostReport from './pages/StaffPerformanceTotalCostReport';
import StaffPerformanceServiceCostList from './pages/StaffPerformanceServiceCostList';
import ServiceCountByStatusReport from './pages/ServiceCountByStatusReport';
import ServiceCountByStageReport from './pages/ServiceCountByStageReport';
import StaffAgencyAccountingBook from './pages/StaffAgencyAccountingBook';
import Contacts from '../Pages/Contacts';
import ServiceAccountingReportByProductType from './pages/ServiceAccountingReportByProductType';
import ProductBugReport from './pages/ProductBugReport';
import ServiceCostAndIncome from './pages/ServiceCostAndIncome';
import ServiceCostAndIncomeByProductType from './pages/ServiceCostAndIncomeByProductType';
import StaffPerformanceTotalCostReportMonthly from './pages/StaffPerformanceTotalCostReportMonthly';
import SwappedSerialsReport from './pages/SwappedSerialsReport';
import FixableSerialsReport from './pages/FixableSerialsReport';
import ServiceCostAndIncomeByProduct from './pages/ServiceCostAndIncomeByProduct';
import ServiceCountByConsiderReport from './pages/ServiceCountByConsiderReport';
import ServiceStageAndStatusReport from './pages/ServiceStageAndStatusReport';
import GuaranteeCardsAssignedToAgencies from './pages/GuaranteeCardsAssignedToAgencies';
import VIPServices from './pages/VIPServices';
import ReportGenerator from './pages/ReportGenerator';
import ServiceTurnaroundTimeReport from './pages/ServiceTurnaroundTimeReport';
import AgentPanel from './pages/AgentPanel';
import SerialHistoryReport from './pages/SerialHistoryReport';

const requireAuth = (setUser) => {
  const token = localStorage.getItem('token');
  if (token !== null && token) {
    setUser(token);
  } else {
    setUser(null);
  }
}


function App(props) {
  const dispatch = useDispatch();
  const [pending, setPending] = useState(true);
  const [currentUser, setUser] = useState(null);
  const [forgetPassword, setForgetPassword] = useState(false);
  const [menuWidth, setMenuWidth] = useState(false);
  const { setModalAboutUs, setQAList } = props;
  const userInfo = JSON.parse(localStorage.getItem("UserInfo"));
  useEffect(() => {
    requireAuth(setUser);
    setPending(false);
    dispatch(getActiveSubsystems());
    dispatch(getAppConfig());
    document.getElementById("CompanyName")?.setAttribute("systemname", "سیستم خدمات");
  }, []);
  return (
    <div className="App">
      <Router>
        <ModalDialog />
        <ModalEnlargeImage />
        {currentUser &&
          <Fragment>
            <PopupMenu />
            <div style={{ height: "20px" }}>
              {isMobileApp() && <Menu menuName="Service" />}
              {isWebApp() &&
                <Fragment>
                  <span style={{ fontSize: "30px", cursor: "pointer", position: "absolute", right: "15px", top: "6px" }} onClick={() => { setMenuWidth("250px") }}>&#9776;</span>
                  <MenuWide menuWidth={menuWidth} setMenuWidth={setMenuWidth} currentUser={currentUser} setModalAboutUs={setModalAboutUs} menuName="Service" setQAList={setQAList} />
                </Fragment>}
            </div>
            <Switch>
              <Route path="/Services/Service/:serviceID/:serviceType"><Service /> </Route>
              <Route path="/Services/tasks"><Tasks /> </Route>
              <Route path="/Services/myTasks"><MyTasks /> </Route>
              <Route path="/Services/GuaranteeCardStatus"><GuaranteeCardStatus /></Route>
              <Route path="/Services/GuaranteeStatusResult"><GuaranteeStatusResult /></Route>
              <Route path="/Services/Profile"><Profile /></Route>
              <Route path="/Services/RequestPassword"><RequestPassword /></Route>
              <Route path="/Services/ServiceInvoice/:serviceID/:serviceType"><ServiceInvoice /></Route>
              <Route path="/Services/PartRequest/:ID"><PartRequest /></Route>
              <Route path="/Services/SearchProductRequest"><SearchProductRequest /></Route>
              <Route path="/Services/UserProfile"><UserProfile /></Route>
              <Route path="/SearchCommands"><SearchCommands /></Route>
              <Route path="/Services/MyCommands"><MyCommands /></Route>
              <Route path="/Services/Commands/:commandID/:attachmentID/:attachmentType"><Commnands /></Route>
              <Route path="/Services/AddEditStaff/:isAgency/:id"><AddEditStaff /></Route>
              <Route path="/Services/SearchStaff"><SearchStaff /></Route>
              <Route path="/Services/CustomerRequestWithoutLoginList"><CustomerRequestWithoutLoginList /></Route>
              <Route path="/PrintViewer/:reportName/:designMode"><PrintViewer /></Route>
              <Route path="/Services/ServiceRejectHistory"><ServiceRejectHistory /></Route>
              <Route path="/Services/ManageTransportationChart"><ManageTransportationChart /></Route>
              <Route path="/Services/ManageSendingStaffList"><ManageSendingStaffList /></Route>
              <Route path="/Services/GuaranteeCardsManagement"><GuaranteeCardsManagement /></Route>
              <Route path="/UserDashboard"><UserDashboard /></Route>
              <Route path="/SMSTemplates"> <ModalSMSTemplates /></Route>
              <Route path="/SearchSentSMS"><SearchSentSMS /></Route>
              <Route path="/SearchReceivedSMS"><SearchReceivedSMS /></Route>
              <Route path="/Services/ProductBugDetailedReport"><ProductBugDetailedReport /></Route>
              <Route path="/Services/ProductBugReport"><ProductBugReport /></Route>
              <Route path="/Services/ServiceAccountingReport"><ServiceAccountingReport /></Route>
              <Route path="/Services/DefinedServiceCostAggregate"><DefinedServiceCostAggregateReport /></Route>
              <Route path="/Services/DefinedServiceCostDetail/:id"><DefinedServiceCostDetailedReport /></Route>
              <Route path="/Services/StaffPerformanceTotalCost"><StaffPerformanceTotalCostReport /></Route>
              <Route path="/Services/StaffPerformanceServiceCostList/:staffID"><StaffPerformanceServiceCostList /></Route>
              <Route path="/Services/ServiceCountByStatusReport"><ServiceCountByStatusReport /></Route>
              <Route path="/Services/ServiceCountByStageReport"><ServiceCountByStageReport /></Route>
              <Route path="/Services/ServiceCountByConsiderReport"><ServiceCountByConsiderReport /></Route>
              <Route path="/Services/StaffAgencyAccBook"><StaffAgencyAccountingBook /></Route>
              <Route path="/Services/ServiceCostAndIncome"><ServiceCostAndIncome /></Route>
              <Route path="/Services/ServiceCostAndIncomeByProductType"><ServiceCostAndIncomeByProductType /></Route>
              <Route path="/Services/ServiceCostAndIncomeByProduct"><ServiceCostAndIncomeByProduct /></Route>
              <Route path="/Services/ServiceStageAndStatus"><ServiceStageAndStatusReport /></Route>
              <Route path="/Services/ServiceAccountingReportByProductType"><ServiceAccountingReportByProductType /></Route>
              <Route path="/Services/StaffPerformanceTotalCostReportMonthly"><StaffPerformanceTotalCostReportMonthly /></Route>
              <Route path="/Services/FixableSerialsReport"><FixableSerialsReport /></Route>
              <Route path="/Services/SwappedSerialsReport"><SwappedSerialsReport /></Route>
              <Route path="/Services/GuaranteeCardsAssignedToAgencies"><GuaranteeCardsAssignedToAgencies /></Route>
              <Route path="/Services/VIPServices"><VIPServices /></Route>
              <Route path="/Services/ServiceTurnaroundTimeReport"><ServiceTurnaroundTimeReport /></Route>
              <Route path="/Contacts"><Contacts /></Route>
              <Route path="/Services/ReportGenerator"><ReportGenerator /></Route>
              <Route path="/Services/SerialHistoryReport"><SerialHistoryReport /></Route>
              <Route path={userInfo?.HomePage === "Services" || userInfo?.HomePage == "AgentPanel" ? "/" : "/Services"}>
                {userInfo?.HomePage === "Services" ?
                  <HomePage /> :
                  <AgentPanel />
                }
              </Route>
            </Switch>
          </Fragment>
        }
        {pending &&
          <Loader type="BallTriangle"
            color="#bb1370"
            height={50}
            width={50} />}
        {!currentUser && !pending && forgetPassword &&
          <Switch>
            <Route path="/ForgetPassword"><ForgetPassword setForgetPassword={setForgetPassword} /></Route>
          </Switch>
        }
      </Router>
    </div>
  );
}

export default App;
